<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="fm1">‘Vietnam Helicopter “TINS”* From Americal Division Artillery Air Section’</p>
<p class="fm">Chu Lai, Vietnam 1968 and 1969</p>
<p class="fm2">*TINS, an acronym for war stories that are more or less supposed to be true: ‘This is no shit.’</p>
<div class="img_container">
<img alt="images" src="images/front.jpg"/>
</div>
<p class="fm1">Driving a Scout Helicopter in Vietnam can be Dangerous to your Health!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_front.vue?35a345e6